import { useLanguage } from "../../i18n/LanguageContext";
import "./loading.css";

export const Loading = () => {
  const { t } = useLanguage();
  const brand = "JCAS".split("");

  return (
    <div className="loading">
      <main className="loading-container">
        <section className="loading-container__name">
          {brand.map((letter, index) => (
            <span
              className="loading-container__name__text"
              key={`${letter}-${index}`}
              style={{ animationDelay: `${index * 0.09}s` }}
            >
              {letter}
            </span>
          ))}
        </section>
      </main>

      <section className="position">
        <h1>{t("loading.role")}</h1>
      </section>
    </div>
  );
};
